import React from "react";

interface HeroLCPImageProps {
  isMobile: boolean;
}

const HeroLCPImage = ({ isMobile }: HeroLCPImageProps) => {
  // Immediate render for LCP optimization - no delays or animations
  return (
    <div className={`w-full lg:w-1/2 relative ${isMobile ? 'mt-2' : 'mt-6 lg:mt-0'} flex justify-center`}>
      <div className={`relative overflow-hidden ${isMobile ? 'mx-4 rounded-2xl shadow-2xl' : 'rounded-2xl sm:rounded-3xl shadow-2xl'}`} style={{
        width: isMobile ? '320px' : '544px',
        height: isMobile ? '320px' : '544px',
        aspectRatio: '1/1',
        flexShrink: 0
      }}>
        {!isMobile && (
          <div 
            className="absolute inset-0 rounded-2xl sm:rounded-3xl -z-10 shadow-xl" 
            style={{ backgroundColor: 'rgba(31, 31, 30, 1)' }}
          ></div>
        )}
        <img 
          src="/lovable-uploads/bdb462c7-a36b-4689-bf6d-e2da753920df.png"
          alt="AI Future People" 
          className="w-full h-full object-cover"
          width={544}
          height={544}
          loading="eager"
          sizes="(max-width: 768px) 320px, 544px"
          style={{
            display: 'block'
          }}
        />
      </div>
    </div>
  );
};

export default HeroLCPImage;